import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import BrandServiceLinks from "../components/BrandServiceLinks";
import Faqs from "../components/Faqs";
import BrandServiceCta from "../components/BrandServiceCta";
import serviceBg from "../assets/hero3.png";
import "./BrandService.css";
import { getBrandPageData } from "../data/brandPageData";

const BrandServicePage = ({ brandKey }) => {
  const page = getBrandPageData(brandKey);

  if (!page) {
    return null;
  }

  const canonicalUrl = page.canonical || `https://customersupports24x7.in/${page.slug}`;

  return (
    <>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.description} />
        <meta name="keywords" content={page.keywords} />
        <meta property="og:title" content={page.title} />
        <meta property="og:description" content={page.description} />
        <meta
          property="og:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={page.title} />
        <meta name="twitter:description" content={page.description} />
        <meta
          name="twitter:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <div className="brand-service-banner">
        <InnerBanner
          title={page.heroTitle}
          bgImage={serviceBg}
          brand={brandKey}
          showActions
        />
      </div>

      <div className={`brand-service-page ${brandKey}-page`}>
        <p style={{ textAlign: "justify" }}>{page.intro}</p>
        <p style={{ textAlign: "justify" }}>{page.details}</p>

        <BrandServiceLinks brand={brandKey} />

        <div className="card brand-info-card">
          <h2>Our {page.brand} Appliance Services Include</h2>
          <ul className="brand-check-list">
            {page.services.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="card brand-info-card">
          <h2>Common {page.brand} Appliance Issues We Fix</h2>
          <ul className="brand-check-list">
            {page.issues.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="card brand-info-card brand-why-card">
          <h2>Why Choose Our {page.brand} Service Support?</h2>
          <ul className="brand-check-list">
            <li>Trained technicians for {page.brand} appliance repairs</li>
            <li>Quick response and doorstep support across Bangalore</li>
            <li>Clear diagnosis with practical repair solutions</li>
            <li>Service support for major home appliance categories</li>
          </ul>
        </div>

        <BrandServiceCta
          title={`Book ${page.brand} Service Today`}
          text={`Schedule quick ${page.brand} appliance repair support anywhere in Bangalore.`}
        />
      </div>
      <Faqs brand={brandKey} />
    </>
  );
};

export default BrandServicePage;
